import * as React from "react";
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { API } from "aws-amplify";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import { Alert } from "@material-ui/lab";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: any
    prescriptionId: string
    reasonCode: ReasonCode
    response: any
}

enum ReasonCode {
    REPLACEMENT_ORDER = 'REPLACEMENT_ORDER',
    VACATION_ORDER = 'VACATION_ORDER',
    PRESCRIPTION_DATA_CHANGED = 'PRESCRIPTION_DATA_CHANGED'
}

class OverrideConsumptionGuardSection extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            prescriptionId: '',
            reasonCode: ReasonCode.REPLACEMENT_ORDER,
            response: ''
        }

        this.handlePrescriptionIdChange = this.handlePrescriptionIdChange.bind(this);
        this.setReasonCode = this.setReasonCode.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return (
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <TextField
                        style={{width: 400}}
                        label="Prescription Id"
                        variant="outlined"
                        value={ this.state.prescriptionId }
                        onChange={ this.handlePrescriptionIdChange }
                    />
                </Grid>
                <Grid item xs>
                    <FormControl>
                        <InputLabel>Reason Code</InputLabel>
                        <Select
                            value={ this.state.reasonCode }
                            style={{width: 400}}
                            onChange={ this.setReasonCode }
                        >
                            {
                                Object.values(ReasonCode).map(value => (
                                    <MenuItem value={ value } key={ value }>
                                        <em>{ value }</em>
                                    </MenuItem>
                                ))

                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Override Prescription
                    </Button>
                </Grid>

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Status</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private handlePrescriptionIdChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ prescriptionId: event.target.value });
    }

    private setReasonCode(event: any) {
        this.setState({ reasonCode: event.target.value });
    }

    private resetOutput() {
        this.setState({ errorMessage: '' });
        this.setState({ response: '' });
    }

    private handleSubmit() {
        this.resetOutput();
        this.callOverridePrescription({
            body: {
                prescriptionId: this.state.prescriptionId,
                reasonCode: this.state.reasonCode
            },
            headers: {}
        });
    }

    private callOverridePrescription(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/prescription/override-consumption-guard';

        console.log(config)
        API.post(apiName, path, config).then((overrideConsumptionGuardResponse: any) => {
            console.log(overrideConsumptionGuardResponse);
            this.setState({ response: overrideConsumptionGuardResponse });
        }).catch((error) => {
            console.log(error);
            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default OverrideConsumptionGuardSection;
